export const INITIAL_SIGNUP_USER = {
	name: '',
	email: '',
	password: ''
};

export const INITIAL_LOGIN_USER = {
	email: '',
	password: ''
};

export const INITIAL_ASSET = {
	id: '',
	name: '',
	price: '',
	amount: '',
	dateOfPurchase: ''
};

// Coin list will be extended to top 20 coins

export const COIN_LIST = [
	{
		id: 'ethereum',
		text: 'Ethereum',
		value: 'Ethereum'
	},
	{
		id: 'bitcoin',
		text: 'Bitcoin',
		value: 'Bitcoin'
	},
	{
		id: 'tether',
		text: 'Tether',
		value: 'Tether'
  },
	{
		id: 'litecoin',
		text: 'Litecoin',
		value: 'Litecoin'
	},
	{
		id: 'basic-attention-token',
		text: 'Basic Attention Token',
		value: 'Basic Attention Token'
	},
	{
		id: 'nem',
		text: 'Nem',
		value: 'Nem'
	},
	{
		id: 'neo',
		text: 'Neo',
		value: 'Neo'
	},
	{
		id: 'binancecoin',
		text: 'Binance Coin',
		value: 'Binance Coin'
	},
	{
		id: 'tron',
		text: 'Tron',
		value: 'Tron'
	}
];
